export default function CompSec_Body_Setting() {
  return (
    <>
      <div className="max-w-6xl mx-auto mt-8 px-4 sm:px-6 lg:px-10 pb-6 md:flex">
        <h1>Hello from Setting</h1>
      </div>
    </>
  );
}
